
import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";
import reqVendaItem from "../../../../services/reqMultiTenant/reqVendaItem";
import MainReportMatrix from "../../matrix";

const ReportCurvaABC = (props) => {
	const options = {
		title: "Curva ABC",
		subTitle: "Relatório de Curva ABC",
		ident: "curvaABC", //usado para definir os event listners
		identFilter: "filterCurvaABC", //usado para definir os event listners
		identReport: "reportCurvaABC", //usado para definir os event listners
		tableColumns: [
			{ key: "classe", label: "Classe", align: "center" },
			{ key: "nome", label: "Descrição", align: "left" },
			{ key: "valor_item", label: "Valor", align: "center", format: "currency" },
			{ key: "perc", label: "Percentual", align: "center" },
		],
		reportColumns: [
			{ key: "classe", label: "Classe", align: "center" },
			{ key: "nome", label: "Descrição", align: "left" },
			{ key: "valor_item", label: "Valor", align: "right", format: "currency" },
			{ key: "perc", label: "Percentual", align: "center" },
		],

		showTime: true, //mostra a hora no filtro de data
		hasActive: false, //ativa o filtro de ativo
		hasSaleType: false,
		parametersDate: [{ id: 1, label: "Data da venda", value: "dtVenda" }],
		parametersFilter: [
			{ id: 1, label: "Categoria", value: "categoria" },
			// { id: 2, label: "Grupo", value: "grupo" },
			// { id: 3, label: "SubGrupo", value: "subgrupo" },
			// { id: 4, label: "Fornecedor", value: "fornecedor" },
			{ id: 2, label: "Referência", value: "referencia" },
		],
		listDataTotal: [{ key: "valor_total", label: "Total dos produtos", format: "currency" }], //usado para mostrar os totais na tela
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };

		const response = await reqVendaItem.curvaABC(newFilterData);

		return response;
	};

	//chama o relatório passando os options e a função fetch e o filtro de pesquisa
	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix options={options} fetch={fetch} FormFilter={FilterReportDateItens}></MainReportMatrix>
		</div>
	);
};

export default ReportCurvaABC;
